<template>
  <el-scrollbar style="height: 100%">
    <eco-tree
      :data="treeData"
      :props="defaultProps"
      :highlight-current="highlightCurrent"
      node-key="id"
      :show-checkbox="showCheckbox"
      :render-content="renderContent"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      @check="check"
      :support-filter="supportFilter"
      :default-expanded-keys="defaultExpandedKeys"
      @node-expand="nodeExpend"
      @node-collapse="nodeCollapse"
      @refresh="loadData"
      ref="ecoTree"
    >
      <!-- 作用域插槽：插槽prop -->
      <slot slot-scope="{ node, data }" :node="node" :data="data"></slot>
    </eco-tree>
  </el-scrollbar>
</template>

<script>
import org from '@/api/org.js'
import utils from '@/eco-ui-util.js'
import req from '@/request'
import utilss from '@/utils.js'
export default {
  name: 'eco-org-tree',
  props: {
    defId: {
      type: String | Number,
      required: true
    },
    isOrigin: {
      type: Boolean,
      default: false
    },
    supportFilter: {
      type: Boolean,
      default: false
    },
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    renderContent: {
      type: Function
    }
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultExpandedKeys: []
    }
  },
  methods: {
    handleNodeClick(node) {
      this.$emit('node-click', node)
    },
    check(data, checkedObj) {
      this.$emit('check', data, checkedObj)
    },
    collectChildren(arr) {
      let result = []
      arr.forEach((e) => {
        // 遍历对象的属性
        result = result.concat([{ ...e, children: null }])
        if (e.children && e.children.length) {
          result = result.concat(this.collectChildren(e.children))
        }
      })

      return result
    },
    copyNewSet(data, arr) {
      const i = arr.find((e) => e.id == data.parentId)
      if (i) {
        arr.push(data)
      } else {
        if (this.treeData && this.treeData.length) {
          data.parentId = this.treeData[0].id
          data.leaf = true
          arr.push(data)
        }
      }
      this.treeData = utils.tile2nest(arr)
        this.$emit('setParentData', {
          data: arr,
          treeData: this.treeData
        })
        this.$message.success('复制成功')
    },
    loadData(cb) {
      if (this.defId) {
        if (this.isOrigin) {
          this.getOriginTree()
        } else {
          let data = []
          let url = window.context.third + '/ldap/getSyncRule?demId=' + this.defId
          req
            .get(url)
            .then((rp) => {
              const res = rp.data
              if (res && res.value) {
                const arr = JSON.parse(res.value)
                data = this.collectChildren(arr[0].children)
                data = data.concat([{ ...arr[0], children: null }])
                this.dataSet(data)
              } else {
                this.getOriginTree()
              }
            })
            .finally(() => {
              cb && cb()
            })
        }
      }
    },
    getOriginTree() {
      var param = {
        demId: this.defId
      }
      org.getByParentAndDemToTree(param).then((res) => {
        this.dataSet(res)
      })
    },

    dataSet(data) {
      data = data.filter((e) => {
        return e.status != '0'
      })
      this.treeData = utils.tile2nest(data)
      this.$emit('setParentData', {
        data: data,
        treeData: this.treeData
      })
    },
    noApiLoad(data, obj, flag) {
      if (flag) {
        const index = data.findIndex((i) => i.id == obj.id)
        if (index > -1) {
          data[index].parentId = obj.parentId
          data[index].leaf = !!obj.parentId
        }
      } else {
        data = data.filter((e) => {
          return e.id != obj.id
        })
      }
      this.treeData = flag ? utils.tile2nest(data) : this.delSetArr(data, obj)
      this.$emit('setParentData', {
        data: data,
        treeData: this.treeData
      })
    },
    delSetArr(data, obj) {
      let subOrgIds = []
      data.forEach((e) => {
        if (e.id == obj.parentId) {
          subOrgIds.push(obj.id)
        }
        if (e.parentId == obj.id) {
          subOrgIds.push(e.id)
        }
        if (subOrgIds.includes(e.parentId)) {
          subOrgIds.push(e.id)
        }
      })
      const i = data.findIndex((e) => {
        return e.id == obj.parentId
      })
      data[i].subOrgIds = subOrgIds
      data = data.filter((e) => {
        return !subOrgIds.includes(e.id)
      })
      return utils.tile2nest(data)
    },
    nodeExpend(data) {
      this.defaultExpandedKeys.push(data.id) // 在节点展开是添加到默认展开数组
    },
    nodeCollapse(data) {
      this.defaultExpandedKeys.splice(this.defaultExpandedKeys.indexOf(data.id), 1)
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
<style lang="scss" scoped>
>>> .el-tree .el-tree__empty-block {
  margin: 20px 20px;
}

>>> .el-tree {
  width: 100%;
}

>>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
